
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { buildInfo } from './environments/build-info';

if (environment.production) {
  enableProdMode();
}

// Versão para controle de deploy (verificar via console ou DevTools)
console.log(`%cGlobalManage v${buildInfo.version} · ${environment.envName} · ${buildInfo.buildDate}`, 'color: #0066cc; font-weight: bold; font-size: 12px');
if (buildInfo.gitHash) {
  console.log(`%cGit: ${buildInfo.gitHash}`, 'color: #666; font-size: 10px');
}

// Adicionar versão ao elemento raiz para fácil verificação
platformBrowserDynamic().bootstrapModule(AppModule)
  .then(() => {
    const appRoot = document.querySelector('app-root');
    if (appRoot) {
      appRoot.setAttribute('data-app-version', buildInfo.version);
      appRoot.setAttribute('data-build-date', buildInfo.buildDate);
      if (buildInfo.gitHash) {
        appRoot.setAttribute('data-git-hash', buildInfo.gitHash);
      }
    }
  })
  .catch(err => console.error(err));
